import { useEffect, useState } from "react";
import './Onboarding.css'
import { useDispatch, useSelector } from "react-redux";
import { checkUserFields, selectUserInfo, updateUserData, updateUserField } from "../../features/User/userSlice";
import { selectCurrentLang, selectTranslations } from "../../services/i18n/i18nSlice";


import TitleH1 from "../../components/TitleH1";
import Text from "../../components/Text";
import Button from "../../components/Button";
import Form from 'react-bootstrap/Form';

import hands_img from '../../assets/images/demo/high-five-hand.svg'
import calendar_img from '../../assets/images/demo/calendar.svg'
import preview_img from './images/step_0/preview.png'

import lock_img from '../../assets/images/locker.svg'
import arrow_img from '../../assets/images/arrow-back.svg'

import s_0_0 from './images/step_0/users.svg'
import s_0_1 from './images/step_0/formazione.svg'
import s_0_2 from './images/step_0/verifica.svg'
import s_0_3 from './images/step_0/stats.svg'
import s_0_4 from './images/step_0/art.svg'

import img_1 from '../../assets/images/demo/upgrade_1.svg'
import img_2 from '../../assets/images/demo/upgrade_2.svg'
import img_3 from '../../assets/images/demo/upgrade_3.svg'

import FloatingLabel from "react-bootstrap/esm/FloatingLabel";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { fetchRequestContact } from "./DemoApi";

import { toast } from "react-toastify";
import { setLoading } from "../../services/global/globalSlice";



export default function UpgradeScreen(props) {

    const userInfo = useSelector(selectUserInfo)
    const t = useSelector(selectTranslations);
    const missingFields = useSelector(checkUserFields)

    const [leadData, setLeadData] = useState({
        contact_email: userInfo?.user_data.email || ""
    })

    const [showFeedback, setShowFeedback] = useState(null)
    const [validatedForm, setValidatedForm] = useState(false);

    const dispatch = useDispatch()

    let navigate = useNavigate()

    const handleSubmitLead = async (event) => {
        const form = event.currentTarget;
        setValidatedForm(true);
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            dispatch(setLoading(true))
            event.preventDefault();
            event.stopPropagation();

            const response = await fetchRequestContact({
                lead_email: leadData.contact_email
            })
            if(response.success){
                setShowFeedback('contact')
            } else {
                toast.error(response.error)
            }
            dispatch(setLoading(false))
        }
        
    };

    const movetoFeedback = () => {
        setShowFeedback('booking')
    }

    useEffect(()=>{
        setLeadData({
            ...leadData,
            contact_email: userInfo?.user_data.email
        })
    },[userInfo])
    
    return(
        <>
            <div id="demoScreen">
                <header className="header_shadow"> 
                    <div>
                        <Link to='/'>
                            <img src={arrow_img} alt='' />
                        </Link>
                    </div>
                </header>
                {
                    !showFeedback  ?
                        <div className="container d-flex ">
                            <div className="w-100">
                                <div className="row w-100 mt-5 align-items-center">
                                    <div className="col-6">
                                        <img src={lock_img} />
                                        <h1 style={{fontSize:'32px'}}>{t.demo.upgrade.title}</h1>
                                        <p style={{fontSize:'20px'}}>{t.demo.upgrade.subtitle}</p>
                                        <p style={{fontSize:'20px'}}><img src={s_0_0} className="me-2"/>{t.demo.upgrade.steps.s_0}</p>
                                        <p style={{fontSize:'20px'}}><img src={s_0_1} className="me-2"/>{t.demo.upgrade.steps.s_1}</p>
                                        <p style={{fontSize:'20px'}}><img src={s_0_2} className="me-2"/>{t.demo.upgrade.steps.s_2}</p>
                                        <p style={{fontSize:'20px'}}><img src={s_0_3} className="me-2"/>{t.demo.upgrade.steps.s_3}</p>
                                        <p style={{fontSize:'20px'}}><img src={s_0_4} className="me-2"/><span dangerouslySetInnerHTML={{__html:t.demo.upgrade.steps.s_4}} /></p>
                                        <a href="https://calendar.app.google/9G941nkzRZSWeGr59" target="_blank" onClick={movetoFeedback}>
                                            <Button className="mt-4" type={'button'}  >
                                                {t.demo.upgrade.book_a_call}
                                            </Button>
                                        </a>
                                    </div>
                                    <div className="col-6">
                                        <img src={preview_img} className="w-100" />
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center mt-5">
                                    <div>
                                        <p className="text-center">{t.demo.upgrade.contact_form_title}</p>
                                        <Form noValidate validated={validatedForm} onSubmit={handleSubmitLead} className="w-100 mt-4">
                                            <Form.Group controlId={'email'} className="mb-3">
                                                <FloatingLabel
                                                    controlId={'email'}
                                                    label={'E-mail'}
                                                    key={'email'}
                                                >
                                                    <Form.Control required type={'email'} placeholder={'E-mail'} name="email" value={leadData.contact_email || ''} />
                                                </FloatingLabel>
                                                <Form.Control.Feedback type="invalid" >
                                                    <small className="text-danger">{t.forms.invalid_input}</small>
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Button className="mx-auto" type={'submit'}  >
                                                {t.demo.upgrade.contact_cta}
                                            </Button>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    : ""
                }
                {
                    showFeedback && showFeedback === "contact" ?
                        <div className="step mt-5 fade-in-animation">
                            <img src={hands_img} className="d-block mx-auto"/>
                            {
                                <>
                                <TitleH1 className="text-start text-lg-center mt-4">{t.demo.upgrade.contact_title}</TitleH1>
                                <Text className="mt-3 mb-0">{t.demo.upgrade.next_steps}:</Text>
                                <ul className="next_steps">
                                    <li>
                                        <img src={img_1} />
                                        <Text className="mb-0">{t.demo.upgrade.upgrade_steps.contact_1}</Text>
                                    </li>
                                    <li>
                                        <img src={img_2} />
                                        <Text className="mb-0">{t.demo.upgrade.upgrade_steps.contact_2}</Text>
                                    </li>
                                    <li>
                                        <img src={img_3} />
                                        <Text className="mb-0">{t.demo.upgrade.upgrade_steps.contact_3}</Text>
                                    </li>
                                </ul>
                                </> 
                            }
                        </div>
                    : ""
                }
                {
                    showFeedback && showFeedback === "booking" ?
                        <div className="step mt-5 fade-in-animation">
                            <img src={calendar_img} className="d-block mx-auto"/>
                            {
                                <>
                                <TitleH1 className="text-start text-lg-center mt-4">{t.demo.upgrade.booking_title}</TitleH1>
                                <Text className="mt-3 mb-0">{t.demo.upgrade.next_steps}:</Text>
                                <ul className="next_steps">
                                    <li>
                                        <img src={img_1} />
                                        <Text className="mb-0">{t.demo.upgrade.upgrade_steps.booking_1}</Text>
                                    </li>
                                    <li>
                                        <img src={img_2} />
                                        <Text className="mb-0">{t.demo.upgrade.upgrade_steps.booking_2}</Text>
                                    </li>
                                    <li>
                                        <img src={img_3} />
                                        <Text className="mb-0">{t.demo.upgrade.upgrade_steps.booking_3}</Text>
                                    </li>
                                </ul>
                                </> 
                            }
                        </div>
                    : ""
                }
            </div>
        </>
    )
}